import React from 'react';
import { FiSearch, FiFilter, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import { useAppContext } from '../context/AppContext';

export const CaseHistory = () => {
  const { cases } = useAppContext();

  const getStatusColor = (status) => {
    switch(status) {
      case 'resolved': return 'text-emerald-400 bg-emerald-400/10 border-emerald-500/20';
      case 'escalated': return 'text-rose-400 bg-rose-400/10 border-rose-500/20';
      default: return 'text-amber-400 bg-amber-400/10 border-amber-500/20';
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-bold text-white">Case History</h1>
          <p className="text-slate-400">Past troubleshooting logs and resolutions.</p>
        </div>
        
        <div className="flex w-full md:w-auto gap-2">
          <div className="relative flex-1 md:w-64">
            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
            <input 
              type="text" 
              placeholder="Search cases..." 
              className="w-full bg-slate-800 border border-slate-700 rounded-lg pl-10 pr-4 py-2 text-sm text-white focus:outline-none focus:border-blue-500"
            />
          </div>
          <button className="p-2 bg-slate-800 border border-slate-700 rounded-lg text-slate-400 hover:text-white">
            <FiFilter />
          </button>
        </div>
      </div>

      <div className="space-y-3">
        {cases.length === 0 ? (
           <div className="text-center py-12 text-slate-500">No cases recorded yet.</div>
        ) : cases.map((c, i) => (
          <div key={i} className="glass-panel p-4 rounded-xl flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:bg-slate-800/80 transition-colors cursor-pointer group">
            <div className="flex items-center gap-4">
              <img src={c.image} alt="Case" className="w-16 h-16 rounded-lg object-cover border border-slate-700" />
              <div>
                <h4 className="font-bold text-slate-200 group-hover:text-blue-400 transition-colors">{c.issue}</h4>
                <p className="text-xs text-slate-500 mt-1">{c.id} • {c.date}</p>
              </div>
            </div>
            
            <div className="flex items-center justify-between sm:justify-end gap-4 w-full sm:w-auto">
              <div className={`px-3 py-1 rounded-full text-xs font-medium border flex items-center gap-1.5 ${getStatusColor(c.status)}`}>
                {c.status === 'resolved' ? <FiCheckCircle /> : <FiAlertCircle />}
                {c.status.charAt(0).toUpperCase() + c.status.slice(1)}
              </div>
              <button className="text-sm text-blue-400 hover:text-blue-300 font-medium hidden sm:block">
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};